/**
 * * Модель элемента списка админов рабочей области
 */
export default class UpsertNamespaceAdminListRequestItem  {
	/**
	 * * Номер пользователя
	 */
	UserId!: number;
	/**
	 * * Флаг возможности изменения очередности задач пользователей в команде по проекту
	 */
	CanCustomizeOrder: boolean = false;
	constructor(obj?: Partial<UpsertNamespaceAdminListRequestItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
